export function validateCartItem(input: {
  productId: string;
  description: string;
  quantity: number;
}) {
  if (!input.productId.trim()) {
    return { ok: false as const, reason: "Informe o código do produto." };
  }
  if (!input.description.trim()) {
    return { ok: false as const, reason: "Informe a descrição do produto." };
  }

  if (input.quantity < 0) {
    return { ok: false, reason: "A quantidade não pode ser negativa." };
  }
  return { ok: true as const };
}
